import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const RodRequestDetailsHeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-image: linear-gradient(92deg, ${theme.colors.bechtel.blue[700]}, ${theme.colors.bechtel.blue[1000]});
  `}
  box-shadow: rgba(0 0 0 / 0.2) 0px 1px 8px 0px, rgba(0 0 0 / 0.12) 0px 3px 3px -2px, rgba(0 0 0 / 0.14) 0px 3px 4px 0px;
`;
